import { useQuery } from '@tanstack/react-query'
import { fromGuaranteeCalculationResponse } from '../models/mapper'
import { fetchGuaranteeCalculationV3 } from './http'
import { QueryKeys } from '../../../key-registry'

export async function fetchGuaranteeCalculation(transitOperationId: number, exchangeRate: number) {
  const { data } = await fetchGuaranteeCalculationV3(transitOperationId, exchangeRate)

  return fromGuaranteeCalculationResponse(data)
}

export function useFetchGuaranteeCalculation(
  transitOperationId: number | null,
  exchangeRate: number,
  enabled: boolean,
) {
  return useQuery({
    queryKey: QueryKeys.transitOperation.guaranteeCalculation({ transitOperationId, exchangeRate }),
    queryFn: () => fetchGuaranteeCalculation(transitOperationId as number, exchangeRate),
    enabled: enabled && !!transitOperationId,
    staleTime: 0,
  })
}
